import { Button } from '@/components/primitives/button'
import { cn } from '@/lib/cn'

function EyeIcon() {
  return (
    <svg aria-hidden className="size-[18px] shrink-0" fill="none" viewBox="0 0 20 20">
      <path
        d="M2.25 10s2.65-5 7.75-5 7.75 5 7.75 5-2.65 5-7.75 5-7.75-5-7.75-5Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.7"
      />
      <path
        d="M10 12.25a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.7"
      />
    </svg>
  )
}

function EyeOffIcon() {
  return (
    <svg aria-hidden className="size-[18px] shrink-0" fill="none" viewBox="0 0 20 20">
      <path
        d="M4.15 7.35A8.2 8.2 0 0 1 10 5c5.1 0 7.75 5 7.75 5a10.7 10.7 0 0 1-2.3 2.98"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.7"
      />
      <path
        d="M12.75 14.46A8.1 8.1 0 0 1 10 15c-5.1 0-7.75-5-7.75-5a10.8 10.8 0 0 1 2.62-3.3"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.7"
      />
      <path
        d="M8.48 8.38a2.25 2.25 0 0 0 3.14 3.14"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.7"
      />
      <path
        d="m3.15 3.15 13.7 13.7"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.7"
      />
    </svg>
  )
}

export interface PasswordVisibilityToggleProps {
  className?: string
  hideLabel?: string
  isVisible: boolean
  onToggle: () => void
  showLabel?: string
}

/**
 * 可复用的密码可见性切换控件。
 * 组件负责图标状态和可访问性标签，输入框类型仍由调用方控制。
 */
export function PasswordVisibilityToggle({
  className,
  hideLabel = 'Hide password',
  isVisible,
  onToggle,
  showLabel = 'Show password',
}: PasswordVisibilityToggleProps) {
  return (
    <Button
      aria-label={isVisible ? hideLabel : showLabel}
      aria-pressed={isVisible}
      className={cn(
        '-mr-1 !h-8 !w-8 !px-0 !text-[#667085] hover:!bg-transparent hover:!text-[var(--color-text)]',
        className,
      )}
      onClick={onToggle}
      size="sm"
      type="button"
      variant="ghost"
    >
      {isVisible ? <EyeIcon /> : <EyeOffIcon />}
    </Button>
  )
}
